module.exports = __webpack_public_path__ + "img/hammer_ios_802.png";